import React from 'react'
import Decimal from 'decimal.js-light'
import { PriceTypeLabel } from '../list/PriceTypeLabel'
import { noOpPackQuantityProvider } from '../bom/NoOpPackQuantityProvider'

// Available price in dollars
export type ProductPriceAvailable = Decimal
// Price has been queried but is not available
export const ProductPriceUnavailable = null
// Price has not been queried
export const ProductPriceNoData = undefined

export type ProductPriceMapValue = ProductPriceAvailable | typeof ProductPriceUnavailable | typeof ProductPriceNoData

export type MutablePriceMap = Record<string, ProductPriceMapValue>
export type PriceMap = Readonly<MutablePriceMap>

export type ProductPackQuantityAvailable = number
export const ProductPackQuantityUnavailable = null
export const ProductPackQuantityNoData = undefined

export type ProductPackQuantityMapValue = ProductPackQuantityAvailable | typeof ProductPackQuantityUnavailable | typeof ProductPackQuantityNoData

export type MutablePackQuantityMap = Record<string, ProductPackQuantityMapValue>
export type PackQuantityMap = Readonly<MutablePackQuantityMap>

export interface ProductPricingContextShape {
  priceMap: PriceMap
  isFetching: boolean
  requestPricing: (itemNos: string[]) => void
  priceTypeLabel: PriceTypeLabel
  getPackQuantity: (itemNo: string) => (number | null)
  isEnabled: boolean
}

export const ProductPricingContextDefaultValue: ProductPricingContextShape = {
  priceMap: { },
  isFetching: false,
  requestPricing:  () => { return },
  priceTypeLabel: {
    label: '',
    longLabel: '',
  },
  getPackQuantity: noOpPackQuantityProvider,
  isEnabled: false
}

export const ProductPricingContext = React.createContext<ProductPricingContextShape>(ProductPricingContextDefaultValue)